<div
	class="form-control" [formGroup]="form"
	[ngClass]="{ 'not-labelled': label === null }"
	[class.invalid]="isInvalid()"
	[class.valid]="isValid()"
	[class.required]="isRequired()"
	[class.has-validation-icon]="show_validation_icon"
>
	<label for="control" [for]="form_control_id" class="label">{{ label }}{{ getRequired() }} {{ getError() }}</label>
	<input
		id="input"
		type="hidden"
		[id]="form_control_id"
		[attr.name]="form_control_name"
		[formControlName]="form_control_name"
	/>
	<div class="radio-button-group">
		<a
			*ngFor="let option of options"
			class="radio-button-option"
			[class.selected]="form_control.value === option.value"
			(click)="onSelectOption(option.value)"
		>
			<div class="radio"><span></span></div>
			<div>
				<h3>{{ option.name }}</h3>
				<p *ngIf="option.description">{{ option.description }}</p>
			</div>
		</a>
	</div>
	<span *ngIf="info !== null" class="info" [class.highlighted]="highlighted_info">
		{{ info }}
	</span>
</div>
